module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/vi_5-e49855d079cd9f06ca1209f1020252d3.jpg";